import { FC } from 'react';
import { Box, ButtonProps } from '@wix/design-system';
import { viewTemplatePath } from '@components/Hooks/useRouter';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import { useTemplateBi } from '@components/Hooks/useTemplateBi';
import PurchaseTemplateButton from '../PurchaseTemplateButton';
import ViewTemplateButton from './ViewTemplateButton';
import { useTemplateEntry } from '@components/Hooks/useTemplateEntry';

interface PurchaseCTAProps {
  buttonSize?: ButtonProps['size'];
  className?: string;
  isMobileView: boolean;
  purchaseCtaOnTheRight?: boolean;
  setPurchaseError: (isError: boolean) => void;
}

const PurchaseCTAs: FC<PurchaseCTAProps> = ({
  buttonSize,
  className,
  isMobileView,
  purchaseCtaOnTheRight,
  setPurchaseError,
}) => {
  const { template, language } = useTemplateContext();
  const { userDetails } = useHeaderContext();
  const { logBiClick } = useTemplateBi({ is_mobile: isMobileView });
  const { entry } = useTemplateEntry();

  const renderButtons = () => {
    const viewButton = (
      <ViewTemplateButton
        buttonSize={buttonSize}
        viewTemplatePath={viewTemplatePath}
        template={template}
        entry={entry}
        logBiClick={({ clickType }) => logBiClick({ clickType })}
      />
    );

    const purchaseButton = (
      <PurchaseTemplateButton
        templateId={template.id!}
        price={template.price}
        buttonSize={buttonSize}
        logBiClick={() => logBiClick({ clickType: 'purchase' })}
        userDetails={userDetails}
        language={language}
        setPurchaseError={setPurchaseError}
        consentModalProps={{
          hasCustomCode: template.hasVeloOrBlocks,
          onModalBiClick: (clickType: string) => logBiClick({ clickType }),
          isMobileView,
        }}
        privacyPolicyUrl={template?.privacyPolicyUrl ?? ''}
      />
    );

    return purchaseCtaOnTheRight
      ? [viewButton, purchaseButton]
      : [purchaseButton, viewButton];
  };

  return (
    <Box
      gap={'12px'}
      display="flex"
      className={className}
      dataHook="purchase-buttons"
    >
      <> {renderButtons()}</>
    </Box>
  );
};

export default PurchaseCTAs;
